import { COLORS } from '@/constants';
import styled from 'styled-components';

export const IconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  gap: 2px;
  border-radius: 4px;
  background: ${COLORS['white']};
  border: none !important;
  padding: 0px 6px;
  cursor: pointer;

  z-index: 20;
  position: absolute;
  top: 8px;
  left: 8px;
`;

export const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-width: 340px;
  min-width: 200px;
`;
